import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import {
  IndirectTaxProductTaxCodesResponse,
  UseIndirectTaxProductTaxCodesParams,
} from './types';

export function useIndirectTaxProductTaxCodesByCorporationId({
  token,
  filters,
}: UseIndirectTaxProductTaxCodesParams) {
  const { data, mutate, error, isLoading } = useSWR<IndirectTaxProductTaxCodesResponse>(
    filters.corporationId !== undefined
      ? `new-sales-tax/products/taxCodes/corporation/${filters.corporationId}`
      : null,
    SWRFetcher({ method: 'GET' }, token),
    { revalidateOnFocus: false }
  );

  return {
    data: data?.data?.taxCodes,
    mutate,
    error,
    isLoading,
  };
}
